import axios from "axios";
import { config } from "@src/config";

// auth
var _token = localStorage.getItem("token");
const token = {
    get() {
        return _token;
    },
    set( val ) {
        _token = val;
        localStorage.setItem("token", val);
    },
    exists() {
        return !!_token;
    },
    destroy() {
        _token = null;
        localStorage.removeItem("token");
    }
}

// rest
var instance = axios.create({
    baseURL: config.api.base_url,
    // timeout: 10000,
    headers: {
        "X-Requested-With": "XMLHttpRequest"
    },
    validateStatus: function (status) {
        return status >= 200 && status < 300; // default
    },
});
instance.interceptors.response.use( (response) => {
    // nice
    return response;
}, (error) => {
    appContext.gotHttpError(error);
    return Promise.reject(error);
});

var history = [] as any;
const api = (args) => {
    const key = `${args.url}`;
    const find = history.filter( h => h.key ===key );
    if (args.memoization && find.length > 0) {
        return find[0].promise;
    }
    const promise = instance(args);
    if (args.memoization) {
        history.push({
            key,
            promise
        });
    }
    return promise;
}

var appContext;
const bindToApp = (context) => {
    appContext = context;
}

const confirm = (question) => {
    return appContext.confirmPut( question );
}
const alerts =(question) => {
    return appContext.alertsPut(question);
}


export {
    token,
    api,
    bindToApp,
    confirm,
    alerts
};


// WEBPACK FOOTER //
// ./src/services/api.ts